<template>
  <div class="w-full">
    <DatatableReportV3
      v-if="tenantLoaded"
      id="jobs_table"
      ref="jobs_datatable"
      title="All Jobs"
      :source="source"
      :config="config"
      :filters="filters"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { customerClassificationColumns } from "@/lib/customerTypes";

import CONSTANTS from "@/Constants.js";
import DepartmentLink from "@/Department/DepartmentLink.vue";
import JobOpportunityLink from "@/Job/Opportunity/JobOpportunityLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";
import store from "@/vuex/store";
import JobsActionsContextMenu from "./JobsActionsContextMenu.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    ...mapGetters(["jobStatusEnabled"]),
    config() {
      // The default sort is by position, so it moves with the classification
      // columns to stay on the same column.
      const classificationColumns = customerClassificationColumns();

      return {
        responsive: true,
        order: [[3 + classificationColumns.length, "desc"]],
        columns: [
          {
            data: "job",
            responsivePriority: 2,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.jobs
          },
          {
            data: "job_status",
            responsivePriority: 3,
            title: "Job Status",
            filterName: "job_status_id",
            orderable: false,
            visible: this.jobStatusEnabled
          },
          {
            data: "tags",
            responsivePriority: 16,
            title: "Tags",
            orderable: false,
            searchable: false
          },
          ...classificationColumns,
          {
            data: "customer",
            responsivePriority: 1,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers,
            footerClassName: "aggregate-number"
          },
          {
            data: "customer_email",
            responsivePriority: 8,
            title: "Email"
          },
          {
            data: "customer_phone",
            responsivePriority: 7,
            title: "Phone"
          },
          {
            data: "location_name",
            responsivePriority: 10,
            title: "Location Name"
          },
          {
            data: "address",
            responsivePriority: 9,
            orderable: false
          },
          {
            data: "first_appointment",
            responsivePriority: 4,
            title: "First Appointment",
            searchable: false
          },
          {
            data: "appts",
            responsivePriority: 14,
            title: "Appts",
            searchable: false,
            orderable: false
          },
          {
            data: "department",
            responsivePriority: 11,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.departments,
            filterName: "department_id"
          },
          {
            data: "technician",
            responsivePriority: 12,
            title: "Opportunity Owner",
            filterName: "technician_id"
          },
          {
            data: "opportunity_status",
            responsivePriority: 13,
            title: "Opportunity"
          },
          {
            data: "quotes_accepted",
            responsivePriority: 15,
            title: "Accepted Quotes",
            orderable: false,
            searchable: false
          },
          {
            data: "job_total",
            responsivePriority: 5,
            title: "Total",
            searchable: false,
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total
          },
          {
            data: "job_balance",
            responsivePriority: 6,
            title: "Balance",
            searchable: false,
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.balance
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "department-modal-vue",
            component: DepartmentLink,
            options: {
              store
            }
          },
          {
            rootId: "job-opportunity-modal-vue",
            component: JobOpportunityLink,
            options: {
              store
            }
          },
          {
            rootId: "jobs-context-menu-vue",
            component: JobsActionsContextMenu,
            options: {
              store
            }
          },
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      };
    }
  }
};
</script>
